import WorklogItemPlaceholder from './WorklogItemPlaceholder';

export default WorklogItemPlaceholder;
